import { makeStyles } from 'tss-react/mui';

const useStylesListItemSummary: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  listItemSummary: {
    display: 'flex !important',
    padding: '10px 20px !important',
    justifyContent: 'space-between !important',
    borderTop: `1px solid ${theme.palette.info.main}`,
    fontSize: 14,
    fontWeight: 500,
  },
}));

export default useStylesListItemSummary;
